import type { Clock } from '../types/clock';

/**
 * Sleep implementation that allows unit tests to replace the clock, so that the
 * tests do not actually need to wait.
 */
export function asyncSleep(clock: Clock, ms: number, signal: AbortSignal | null): Promise<void> {
  if (signal?.aborted) {
    if (signal.reason instanceof Error) {
      throw signal.reason;
    }
    throw new Error('Aborted');
  }

  return new Promise((resolve, reject) => {
    const listener = () => {
      clock.clearTimeout(cookie);
      reject(signal?.reason);
    };
    signal?.addEventListener('abort', listener);

    const cookie = clock.setTimeout(() => {
      signal?.removeEventListener('abort', listener);
      resolve();
    }, ms);
  });
}
